export const downloadFile = ({ url, fileName, target = '_self' }) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.setAttribute('download', fileName);
  downloadLink.setAttribute('target', target);
  downloadLink.click();
};
